import { Component, OnInit, Inject, OnDestroy, ViewEncapsulation } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { preScreenStatus } from 'app/configs/prescreen';

@Component({
  selector: 'salespro-confirm-box',
  templateUrl: './confirm-box.component.html',
  styleUrls: ['./confirm-box.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ConfirmBoxComponent implements OnInit {
  title = '';
  content = '';
  buttonHide = false;
  p24Hide = false;
  siteName = '';
  contentTwo = '';
  hasPrescreening = false;
  preScreenPopUp = false;
  isBypass = false;
  approvedBy = '';
  bypassReason = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) private _data: any,
    public matDialogRef: MatDialogRef<ConfirmBoxComponent>,
  ) {
    this.title = this._data.title;
    this.content = this._data.content;
    this.buttonHide = this._data && this._data.buttonHide ? true : false;
    this.p24Hide = this._data && this._data.p24Hide ? true : false;
    this.siteName = this._data && this._data.siteName ? this._data.siteName : '';
    this.contentTwo = this._data && this._data.contentTwo ? this._data.contentTwo : '';
    this.hasPrescreening = this._data && this._data.preScreenStatus ? 
      this._data.preScreenStatus === preScreenStatus.success : false;
    this.preScreenPopUp = this._data.preScreenPopUp;
    this.isBypass = Boolean(this._data && this._data.isBypass);
    if (this._data && this._data.approvedBy) {
      this.approvedBy = this._data.approvedBy;
    }
    if (this._data && this._data.bypassReason) {
      this.bypassReason = this._data.bypassReason;
    }
  }
  ngOnInit() {}
  onModalClose() {
    this.matDialogRef.close({
      continueFinance: false,
    });
  }

  onConfirm(){
    this.matDialogRef.close({
      continueFinance: true,
    });
  }

  onBypassConfirm() {
    this.matDialogRef.close({
      bypass: true,
      approved_by: (this.approvedBy || '').trim(),
      reason: (this.bypassReason || '').trim(),
    });
  }
}
